"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4618],{

/***/ 69773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var BottomQ = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xmlns: "http://www.w3.org/2000/svg",
        className: "case-studies__quote__icon case-studies__quote__icon--top rotate-180",
        width: "10",
        height: "10",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("symbol", {
                    id: "quote",
                    viewBox: "0 0 9 8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M4.155 7.9H0V4.699a4.715 4.715 0 0 1 .737-2.833A5.98 5.98 0 0 1 3.258.1l.945 1.7a4.584 4.584 0 0 0-1.568 1.029c-.278.344-.44.767-.463 1.209h1.983V7.9zM9 7.9H4.845V4.699a4.721 4.721 0 0 1 .736-2.833A5.99 5.99 0 0 1 8.103.1L9 1.8a4.58 4.58 0 0 0-1.52 1.029c-.278.344-.44.767-.463 1.209H9V7.9z",
                        fillRule: "evenodd"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                fill: "#FFFFFF",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.155 7.9H0V4.699a4.715 4.715 0 0 1 .737-2.833A5.98 5.98 0 0 1 3.258.1l.945 1.7a4.584 4.584 0 0 0-1.568 1.029c-.278.344-.44.767-.463 1.209h1.983V7.9zM9 7.9H4.845V4.699a4.721 4.721 0 0 1 .736-2.833A5.99 5.99 0 0 1 8.103.1L9 1.8a4.58 4.58 0 0 0-1.52 1.029c-.278.344-.44.767-.463 1.209H9V7.9z",
                    fillRule: "evenodd"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BottomQ);


/***/ }),

/***/ 29310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var TopQ = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xmlns: "http://www.w3.org/2000/svg",
        className: "case-studies__quote__icon case-studies__quote__icon--top",
        width: "10",
        height: "10",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("symbol", {
                    id: "quote",
                    viewBox: "0 0 9 8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M4.155 7.9H0V4.699a4.715 4.715 0 0 1 .737-2.833A5.98 5.98 0 0 1 3.258.1l.945 1.7a4.584 4.584 0 0 0-1.568 1.029c-.278.344-.44.767-.463 1.209h1.983V7.9zM9 7.9H4.845V4.699a4.721 4.721 0 0 1 .736-2.833A5.99 5.99 0 0 1 8.103.1L9 1.8a4.58 4.58 0 0 0-1.52 1.029c-.278.344-.44.767-.463 1.209H9V7.9z",
                        fillRule: "evenodd"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                fill: "#FFFFFF",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.155 7.9H0V4.699a4.715 4.715 0 0 1 .737-2.833A5.98 5.98 0 0 1 3.258.1l.945 1.7a4.584 4.584 0 0 0-1.568 1.029c-.278.344-.44.767-.463 1.209h1.983V7.9zM9 7.9H4.845V4.699a4.721 4.721 0 0 1 .736-2.833A5.99 5.99 0 0 1 8.103.1L9 1.8a4.58 4.58 0 0 0-1.52 1.029c-.278.344-.44.767-.463 1.209H9V7.9z",
                    fillRule: "evenodd"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TopQ);


/***/ }),

/***/ 4618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_icons_Quote_BottomQ__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69773);
/* harmony import */ var src_icons_Quote_TopQ__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29310);
/* harmony import */ var _partials_ImgContainer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3613);




var FourthSection = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-[3rem]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_ImgContainer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    href: "/case-study/13",
                    imgSrc: "/images/home/slider/13-wol.webp",
                    title: "Reveler.io",
                    imgCss: "h-[100vw]",
                    desc: "Sub Pages Redesign"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative top-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "md:h-[80vw] h-[154.54545vw] w-full bg-[#131313] py-[1rem] pl-[0.9rem] pr-[1.2rem]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "backgroundWhiteDotsBlackBgCaseStudyMobile h-full w-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex justify-center items-center h-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "bg-[#131313] md:px-10 pl-5 pr-0 pt-8 xs:pb-5 pb-0 text-white w-[73%] md:w-[62%] xs:mt-[6.7rem] mt-[1.5rem]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: " mb-[27px] md:mb-[28px]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_icons_Quote_TopQ__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "font-bold text-white text-[1.57143rem] leading-[1.22727em] mb-6",
                                        children: "Thinking made visual."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "leading-[1.22727em] text-[1.28571rem]",
                                        children: "How you invest in how users interact with and perceive your product will ultimately make or break the success of your product."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mb-[27px] mt-[25px] mt:mb-[26px]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_icons_Quote_BottomQ__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-[3rem]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_ImgContainer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    href: "/case-study/9",
                    imgSrc: "/images/home/slider/9-wol.webp",
                    title: "Bonsai",
                    imgCss: "h-[100vw]",
                    desc: "Mobile App UI/UX Design"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FourthSection);


/***/ }),

/***/ 3613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable @next/next/no-img-element */ 

var ImgContainer = function(param) {
    var imgSrc = param.imgSrc, imgCss = param.imgCss, href = param.href, css = param.css, title = param.title, desc = param.desc, redSquireCss = param.redSquireCss, isFirstBox = param.isFirstBox;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat(css, " group overflow-hidden"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: href ? href : "#",
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[70%] case-study-overlay",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: imgSrc,
                                    className: "w-full object-cover group-hover:scale-125 duration-[400ms] ease-in-out  ".concat(imgCss ? imgCss : "h-full"),
                                    alt: title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute bottom-0 left-0 h-full w-full group-hover:bg-[rgba(0,0,0,0.6)] duration-[400ms] flex flex-col justify-end z-10",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-[2.14286rem] w-max",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "text-white font-semibold text-[1.14286rem] md:text-[1.57143rem] lg:text-[1.14286rem] mb-[0.3rem]",
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-white font-normal text-[1rem] md:text-[1.42857rem] lg:text-[1rem]",
                                                children: desc
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            redSquireCss && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "bg-primary ".concat(isFirstBox ? " w-[48.5vw]" : "w-[50vw]", " h-[50vw] absolute -z-1 ").concat(redSquireCss)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImgContainer);


/***/ })

}]);